module.exports = __webpack_public_path__ + "static/media/centercode.8a7a169e.svg";